import * as Sentry from '@sentry/vue';
import type { App } from 'vue';
import { browserTracingIntegration, replayIntegration } from '@sentry/vue';
import router from '@/interfaces/router';

export function registerSentry(app: App) {
  Sentry.init({
    app,
    dsn: import.meta.env.SENTRY_DSN,
    environment: import.meta.env.SENTRY_ENVIRONMENT,
    release: import.meta.env.SENTRY_RELEASE,
    integrations: [
      browserTracingIntegration({ router }),
      replayIntegration(), // Optional: for session replay
    ],
    debug: false, // 🔍 See logs in devtools console
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      if (event.message?.includes('Non-critical error')) {
        return null;
      }
      return event;
    },
  });
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.info('[Sentry] Initialized ✔️', {
      dsn: import.meta.env.SENTRY_DSN,
      env: import.meta.env.SENTRY_ENVIRONMENT,
      release: import.meta.env.SENTRY_RELEASE,
    });
  }
}
